
  /*
   * Shopify Common JS
   *
   */
  if ((typeof window.Shopify) == 'undefined') {
    window.Shopify = {};
  }

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @return {String} value - formatted value
   */
	Shopify.formatMoney = function(cents, format){
    if (format == null || format == undefined){
      format = window.globalVariables.money_format || "$";
    }
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);
    function defaultOption(opt, def) {
      
      return (typeof opt == 'undefined' ? def : opt);
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');
      if (isNaN(number) || number == null) { return 0; }
      number = (number/100.0).toFixed(precision);
      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';
      return dollars + cents;
    }
    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }
    return formatString.replace(placeholderRegex, value);
};

let productSlider = null;
let quickShopSlider = null;

/**
  * prevent body Touch event in Touch devices when Overlay is visible
  *
  * @param {event} event - event instance
*/
function bodyTouchMove(event){
  let currentTarget = event.target;
  if (!currentTarget.closest('[data-touch-moveable]')) {
    event.preventDefault();
    return false;
  }
}

/**
  * Limit the number of times a function is called within defined timeout
  *
  * @param {form} form - Form to serialize
*/
const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;
    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

/**
  * Fetch call config
  *
  * @param {string} type - request Accept type
*/
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

function openModal(modal, opener){
  if(modal && opener != undefined) modal.show(opener);
}

/**
  * Dropdown component Events and Methods
  *
  * @param {element} element - Dropdown element
  */
 function dropDownInit(element){
 
  let dropdownParent = element.parentElement;
  const _this = element;

  ["mouseover", "focusin",  "click", "mouseout"].forEach(function(type){ 
    if(type == 'click'){
      dropdownParent.addEventListener(type, (e) => {
        let isSearchOpen = document.querySelector('search-modal')?.classList.contains('open__modal');
        if (isSearchOpen) {
          document.querySelector('.search-modal__close-button')?.click();
          if (dropdownParent.querySelector('.dropdown-menu')) {
            e.preventDefault();
            e.stopPropagation();
            dropdownShow(dropdownParent);
          }
          return;
        }

        e.stopPropagation();
        let currentTarget = e.currentTarget;
        let liveTarget = e.target;
        if(liveTarget.classList.contains('nav-link-title') && currentTarget.querySelector('.submenu') == undefined){
          let linkHref = currentTarget.querySelector('.nav-link').getAttribute('data-href');
          if(linkHref) window.location.href = linkHref;
        }else{
          if (liveTarget && !liveTarget.closest('[data-touch-moveable]') || type == 'click') {
            if (liveTarget.closest('.submenu-toggle')) {
              dropdownToggle(dropdownParent);
            }
          }else{
            dropdownToggle(dropdownParent);
          }
        }
      });
    }else if(type == 'mouseout'){
      dropdownParent.addEventListener(type, (e) => {
        if (document.querySelector('search-modal')?.classList.contains('open__modal')) {
          return;
        }
        let currentTarget = e.currentTarget;
        if(!currentTarget.closest('[data-touch-moveable]')){
          e.stopPropagation();
          dropdownHide(dropdownParent);
        }
      });
    } else if(type == 'mouseover' || type == 'focusin'){
      dropdownParent.addEventListener(type, (e) => {
        if (document.querySelector('search-modal')?.classList.contains('open__modal')) {
          return;
        }
        let currentTarget = e.currentTarget;
        if(!currentTarget.closest('[data-touch-moveable]')){
          dropdownShow(dropdownParent); 
        }
      });
      _this.addEventListener(type, (e) => { 
        if (document.querySelector('search-modal')?.classList.contains('open__modal')) {
          return;
        }
        ChildonFocusChange(dropdownParent); 
      });
    }
  });
  dropdownParent.addEventListener('keyup', (event) => {
    if (event.code?.toUpperCase() === 'ESCAPE'){ dropdownHide(event.currentTarget); }
    if (event.code?.toUpperCase() === 'ENTER'){ dropdownShow(event.currentTarget); }
  });

  function dropdownToggle(dropdownParent) {
    let isActive = dropdownParent.classList.contains('open');
    setTimeout(function(){
      if(!isActive){ dropdownShow(dropdownParent); }
      else if(isActive){ dropdownHide(dropdownParent); }
    }, 50);
  }

  function dropdownShow(dropdownParent){
    _this.setAttribute('aria-expanded', true);
    if(!dropdownParent.closest('[data-role="drawer"]')){
      dropdownParent.classList.add('open');
    }else{
      Utility.toggleElement(dropdownParent, 'open');
    }
    if (dropdownParent.querySelector('ul.dropdown-menu')) {
        document.querySelector('.search-modal__close-button')?.click();
    }
  }

  function dropdownHide(dropdownParent){
    _this.setAttribute('aria-expanded', false);
    if(!dropdownParent){
      return;
    }

    if(!dropdownParent.closest('[data-role="drawer"]')){
      dropdownParent.classList.remove('open');
    }else{
      Utility.toggleElement(dropdownParent, 'close');
    }
    if(event && event.type == 'mouseout' && dropdownParent.parentElement.closest('.dropdown')){
      dropdownParent.parentElement.closest('.dropdown').classList.remove('open');
    }

    let childDropdowns = dropdownParent.querySelectorAll('.dropdown.open');
    if(childDropdowns.length > 0){
      childDropdowns.forEach(function(child){
        child.classList.remove('open');
        if(child.querySelector('a[data-toggle="open"]'))
          child.querySelector('a[data-toggle="open"]').setAttribute('aria-expanded', false);
      });
    }
  }

  function ChildonFocusChange(dropdownParent){
    let _this = this;
    let openDropdowns = Array.from(dropdownParent.parentElement.querySelectorAll('.dropdown.open'));
    let currentIndex = openDropdowns.indexOf(dropdownParent);
    openDropdowns.forEach((ele) => {
      let eleIndex = openDropdowns.indexOf(ele);
      if(eleIndex != currentIndex){ dropdownHide(ele); }
    });
  }

  let closeBtn = dropdownParent.querySelector('.close-submenu');
  if(closeBtn){
    closeBtn.addEventListener('click', (event)=>{
      event.preventDefault();
      let parentElement = event.currentTarget.closest('.dropdown');
      dropdownToggle(parentElement);
    });
  };
}

const allDropdowns = document.querySelectorAll('a[is="drop-down"]');
allDropdowns.forEach(function(ele) {
  dropDownInit(ele)
  ele.closest('.nav-item').querySelectorAll('[data-link_handle]').forEach((handleEle)=>{
    handleEle.addEventListener('mouseover',()=>{
      if (document.querySelector('search-modal')?.classList.contains('open__modal')) {
        return;
      }
      let handle=handleEle.getAttribute('data-link_handle');
      document.querySelectorAll('[data-link_collection_handle]').forEach((ele)=>{
        ele.classList.add('d-none');
      })
      document.querySelectorAll(`[data-link_collection_handle="${handle}"]`).forEach((connectedHandle)=>{
        connectedHandle.classList.remove('d-none')
      })
    });
  })
});

/**
 * Close SubMenu Dropdowns on Regular Nav Item fous or click
 *
 * @param {element} element - Dropdown element
 */
function defaultNavItem(element){
  let _this = element;
  ["focusin", "click", "mouseover", "mouseout"].forEach(function(type){
    _this.addEventListener(type, (e) => {
      if (document.querySelector('search-modal')?.classList.contains('open__modal')) {
        if (type == 'click') {
          document.querySelector('.search-modal__close-button')?.click();
        }
        return;
      }
      let currentTarget = e.currentTarget;
      if(!currentTarget.closest('[data-touch-moveable]')){
        hideDropdown(_this.parentElement);
      }
    });
  });

  ["click", "touchend"].forEach(function(type){
    _this.addEventListener(type, (e) => {
      if (_this.closest('.sleep') || _this.closest('.swim') || _this.closest('.navbar-mobile .accordion-link-title_new')) {
          deleteCookie("mobile_menu_items");
      }
      e.stopPropagation();
    });
  });

    function deleteCookie(name) {
        document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=" + location.hostname + ";";
    }

  function hideDropdown(dropdownParent){
    let openDropdowns = Array.from(dropdownParent.parentElement.querySelectorAll('.dropdown.open'));
    openDropdowns.forEach((ele) => {
      ele.classList.remove('open');
      ele.querySelector('[is="drop-down"]').setAttribute('aria-expanded', false);
    });
  }
}

const allDefaultNav = document.querySelectorAll('a[is="simple-menu-item"]');
allDefaultNav.forEach(function(ele) {
  defaultNavItem(ele);
});

class ModalDialogOpener extends HTMLElement {
    constructor() {
        super();
        try {
            this.modalOpener = this.querySelector('[data-modal-opener]');
            this.modalId = this.modalOpener?.getAttribute("data-modal-opener");
            this.modalToOpen = document.querySelector(`modal-dialog#${this.modalId}`)

            this.addEventListener('click', (event) => {
                if (event.target.closest('[data-modal-opener]') || event.target.querySelector('[data-modal-opener]')) {
                    this.modalToOpen?.show(this.modalOpener);
                }
            });
        } catch (e) {
            console.log(e)
        }
    }
}

customElements.define('modal-dialog-opener', ModalDialogOpener);
/**
 * Modal Dialogue
 *
 */
class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.modal = this.querySelector('.modal');
    this.modalOpeners = document.querySelectorAll('[data-modal-opener="'+this.id+'"]');
    if(this.modalOpeners.length > 0) {
      this.modalOpeners.forEach((opener)=>{
        opener.addEventListener('click', ()=>{
          this.show(opener);
        });
      });
    }

    

    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-modal-opener="'+this.id+'"]');
      if (opener) this.show(opener);
    });

    

    if(this.querySelector('[id^="ModalClose-"]')){
      this.querySelectorAll('[id^="ModalClose-"]').forEach(ele => {
        ele.addEventListener('click',this.hide.bind(this))
      });
    }
 
    this.addEventListener('click', (event) => {
      if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      if(event.target.classList.contains('modal')) {
        if (!event.target.getAttribute('data-persistent')) {
          this.hide();
        }
      }
    });

    this.addEventListener('keyup', () => {
      if (event.code?.toUpperCase() === 'ESCAPE') this.hide();
    });

  }

  /**
   * Open the Modal
   * @param {element} opener 
   */
  show(opener) {
    // ToDo remove after ab test
    this.manageSizeGuide(opener)
    try {
      let funnelOpener = opener?.dataset?.modalOpener
      if (funnelOpener === 'funnel-popup') {
        window.VWO = window.VWO || [];
        VWO.event = VWO.event || function () {VWO.push(["event"].concat([].slice.call(arguments)))};

        VWO.event("funnelOpened", {
          count: 1
        });
      }
    } catch (e) {
      console.error(e);
    }

    this.openedBy = opener;
    if (this.id === 'b2b-checkout-modal') {
        document.querySelector('.rebuy-cart__flyout-close')?.click();
    }
    this.modal.classList.add('open');
    siteOverlay.prototype.showOverlay();
    Utility.trapFocus(this);
    Utility.forceFocus(this.querySelector('[id^="ModalClose-"]'));
  }

  /**
   * Close Modal Dialogue
   */
  hide() {
    document.body.classList.remove('overflow-hidden');
    document.querySelector('html.open-funnel')?.classList?.remove('open-funnel');
    this.modal.classList.remove('open');
    
    // Check for other active overlays (modals, cart drawer, menu drawer)
    const otherModalOpen = document.querySelector('.modal.open');
    const activeCart = document.querySelector('cart-form.opened-drawer, #ajax-cart.opened-drawer');
    const activeMenu = document.querySelector('#mobile-menu-drawer.opened-drawer');

    if (!otherModalOpen && !activeCart && !activeMenu) {
        siteOverlay.prototype.hideOverlay();
    }
    Utility.removeTrapFocus(this.openedBy);
  }

  /**
   * Manage size guide
   */
  manageSizeGuide(opener) {
      if (!opener) return;
      if (opener.getAttribute('data-modal-opener') !== 'new-size-guide-popup' || !opener.hasAttribute('data-main-type')) return;
      const tabMap = {
        'bottom':      'size-guide-underwear',
        'top':         'size-guide-bralettes',
        'boxy-tee':    'size-guide-boxy-tee',
        'swim-top':    'size-guide-swim-top',
        'swim-bottom': 'size-guide-swim-bottom',
        'win-top':     'size-guide-win-top',
        'win-bottom':  'size-guide-win-bottom',
      };
      const type = opener.getAttribute('data-main-type');
      const activeTab = tabMap[type] || 'size-guide-tank-top';
      const container = document.querySelector('[data-new-size-guide-tabs]');
      if (!container) return;
      container.querySelectorAll('[data-style-tab]').forEach(tab => {
        const isActive = tab.dataset.styleTab === activeTab;
        if (isActive) {
          tab.classList.add('open');
          tab.dispatchEvent(new Event('click'));
        } else {
          tab.classList.remove('open');
        }
      });
  }
}
customElements.define('modal-dialog', ModalDialog);

// Lazy-cached reference for the site-overlay element (shared across prototype calls)
let _siteOverlayEl = null;
const _getSiteOverlay = () => _siteOverlayEl || (_siteOverlayEl = document.getElementById('site-overlay'));

/**
* Website Overlay for Mobile Menu and Cart Drawer
*/
class siteOverlay extends HTMLElement{
  constructor() {
    super();

    this.menuDrawer = document.querySelector('#mobile-menu-drawer');
    this.cartDrawer = document.querySelector('cart-form.cart-drawer');
    this.bindEvents();
  }

  /**
   * bind Click and Touchend event to this custom component
   */
  bindEvents(){
    this.addEventListener('click', this.onClick.bind(this));
    this.addEventListener('touchend', this.onClick.bind(this));
  }

  /**
   * Click event of Site overlay
   * @param {event} Event instance performed
   */
  onClick(event){
    event.preventDefault();
    event.stopPropagation();
    
    // Direct search for opened drawers to ensure we hit the right one
    const activeCart = document.querySelector('cart-form.opened-drawer, #ajax-cart.opened-drawer');
    if (activeCart) {
      activeCart.querySelector('.close-ajax--cart')?.dispatchEvent(new Event('click'));
    }

    const activeMenu = document.querySelector('#mobile-menu-drawer.opened-drawer');
    if (activeMenu) {
      document.querySelector('.close-mobile--navbar')?.dispatchEvent(new Event('click'));
    }

    this.hideOverlay();
    Rebuy?.SmartCart?.hide();

    document.querySelectorAll('.modal.open').forEach((ele)=>{
      ele.classList.remove('open');
    })

    document.querySelectorAll('.onetime-modal-mobile').forEach((ele)=>{
      ele.classList.add('hide');
    })
  }

  /**
   * Show Overlay
   */
   showOverlay(){
    _getSiteOverlay().classList.add('overlay--body');
    document.body.classList.add('position-fixed-mobile');
    document.body.style.overflowY = "hidden";
    document.body.addEventListener('touchmove', bodyTouchMove, false);
  }

  /**
   * Hide overlay
   */
  hideOverlay(){
    const overlayEl = _getSiteOverlay();
    overlayEl.classList.remove('overlay--body');
    overlayEl.classList.remove('full-overlay');
    document.body.classList.remove('position-fixed-mobile');
    document.body.style.overflowY = "auto";
    document.body.removeEventListener('touchmove', bodyTouchMove, false);

    document.querySelectorAll('.onetime-modal-mobile').forEach((ele)=>{
      ele.classList.add('hide');
    })
  }
}
customElements.define("site-overlay", siteOverlay);


    class customAccountModal extends HTMLElement {
        constructor() {
            super();

            this.registerSection = this.querySelector('[data-register-section]');
            this.resetSection = this.querySelector('[data-recover-password-form]');
            this.loginSection = this.querySelector('[data-login-form]');
            this.loginForm = this.querySelector("#customer_login");
            this.registerForm = this.querySelector("#create_customer");
            this.resetForm = this.querySelector('[action="/account/recover"]');
            this.selectors = {
                recoverShow: '[data-recover-link]',
                recoverHide: '[data-hideresetpass]',
                signUpShow: '.join-button.signup',
                signUpHide: '.join-button.login'
            };
            this.bindActions();
        }

        showEle(ele, hide = true) {
            ele?.classList?.remove('d-none');
            if (hide) {
                this._hideToastMessage();
            }
        }

        hideEle(ele) {
            ele?.classList?.add('d-none');
        }

        _isError(container) {
            let isError = false;
            this.querySelectorAll(`${container} input:not([type="checkbox"])`).forEach(ele => {
                if (!ele.value) {
                    ele.classList.add('error');
                    isError = true;
                } else {
                    ele.classList.remove('error');
                }
            })

            return isError;
        }

        _toastMessage(message, type = 'success') {
            let messageContainer = this.querySelector('[data-account-notifications]');
            messageContainer.innerHTML = message;
            messageContainer.classList.remove('d-none');

            if (type === 'success') {
                messageContainer.classList?.remove('error');
            } else {
                messageContainer.classList?.add('error');
            }
        }

        _hideToastMessage() {
            this.querySelector('[data-account-notifications]')?.classList?.add('d-none');
        }

        bindActions() {
            this.loginForm.addEventListener("submit", async (event) => {
                event.preventDefault();
                this.querySelector('.login-errors.error-container')?.classList?.add('d-none');

                let isError = this._isError('.new-login-wrapper');
                if (isError) return;
                this._loadButton(event.target);
                const email = this.querySelector(".new-login-wrapper #customerEmail").value;
                const password = this.querySelector(".new-login-wrapper #customerPassword").value;
                const params = new URLSearchParams();
                params.append("form_type", "customer_login");
                params.append("utf8", "✓");
                params.append("customer[email]", email);
                params.append("customer[password]", password);

                try {
                    const response = await fetch("/account/login", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded"
                        },
                        body: params.toString()
                    });

                    const html = await response.text();
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, "text/html");

                    const error = doc.querySelector(".errors")?.textContent?.trim();
                    if (error) {
                        if (error.includes('Incorrect')) {
                            this.querySelector('.login-errors.error-container')?.classList?.remove('d-none');
                        }
                        console.log("Login failed: " + error);
                    } else {
                        this._toastMessage('You are logged in successfully!');
                        localStorage.removeItem("wl_count_swym");
                        window.location.reload();
                        console.log("Login successful!");
                    }
                } catch (err) {
                    console.log("Login request failed.");
                    console.error(err);
                } finally {
                    this._loadButton(event.target, false);
                }
            });

            this.registerForm.addEventListener("submit", async (event) => {
                event.preventDefault();
                let isError = this._isError('[data-register-section]');
                if (isError) return;
                this._loadButton(event.target);
                // Get values from inputs
                const firstName = this.querySelector("#customerRegisterForm #registerCustomerFirstName")?.value;
                const lastName = this.querySelector("#customerRegisterForm #customerLastName")?.value;
                const email = this.querySelector("#customerRegisterForm #registerCustomerEmail")?.value;
                const password = this.querySelector("#customerRegisterForm #registerCustomerPassword")?.value;
                const acceptsMarketing = this.querySelector("#customerRegisterForm #accepts_marketing")?.checked ? "true" : "false";

                // Create form data
                const params = new URLSearchParams();
                params.append("form_type", "create_customer");
                params.append("utf8", "✓");
                params.append("customer[first_name]", firstName);
                params.append("customer[last_name]", lastName);
                params.append("customer[email]", email);
                params.append("customer[password]", password);
                params.append("customer[accepts_marketing]", acceptsMarketing);

                try {
                    const response = await fetch("/account", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded"
                        },
                        body: params.toString()
                    });

                    const html = await response.text();
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, "text/html");

                    const error = doc.querySelector(".errors")?.textContent?.trim();
                    if (error) {
                        this._toastMessage(error);
                        console.log("Registration failed: " + error);
                    } else {
                        this._toastMessage("Account created successfully!");
                        window.location.reload();
                        console.log("Account created successfully!");
                    }
                } catch (err) {
                    console.log("Error submitting registration form.");
                    console.error(err);
                    window.location.reload();
                } finally {
                    this._loadButton(event.target, false);
                }
            });

            this.resetForm?.querySelector('[data-reset-password-button]')?.addEventListener("click", async (event) => {
                event.preventDefault();
                event.stopImmediatePropagation();
                this._loadButton(event.target);
                const email = this.querySelector("#resetCustomerEmail").value;

                const params = new URLSearchParams();
                params.append("form_type", "recover_customer_password");
                params.append("utf8", "✓");
                params.append("email", email);

                try {
                    const response = await fetch("/account/recover", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded"
                        },
                        body: params.toString()
                    });

                    const html = await response.text();
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, "text/html");

                    // Check for success or error message
                    let successMsg = doc.querySelector(".note.form-success")?.textContent?.trim();
                    if (!successMsg) {
                        successMsg = doc.querySelector('.new-login-wrapper .success-msg')?.textContent?.trim()
                          || doc.querySelector('.recover_success_message_content')?.textContent?.trim();
                    }
                    const errorMsg = doc.querySelector(".errors")?.textContent?.trim();

                    if (successMsg) {
                        this._toastMessage('Password reset link has been sent to your mail.')
                        console.log("Success: " + successMsg);

                        this.showEle(this.loginSection, false);
                        this.hideEle(this.resetSection);
                    } else if (errorMsg) {
                        console.log("Error: " + errorMsg);
                    } else {
                        this._toastMessage('Something went wrong! Try after sometime.', 'error')
                        console.log("Unexpected response. Please try again.");
                    }
                } catch (err) {
                    console.log("Reset request failed.");
                    console.error(err);
                } finally {
                    this._loadButton(event.target, false);
                }
            });

            this.querySelector(this.selectors.recoverShow)?.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();

                this.hideEle(this.loginSection);
                this.showEle(this.resetSection);
            })

            this.querySelector(this.selectors.recoverHide)?.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();

                this.showEle(this.loginSection);
                this.hideEle(this.resetSection);
            })

            this.querySelector(this.selectors.signUpShow)?.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();

                this.hideEle(this.loginSection);
                this.querySelectorAll('label span.error').forEach(ele => ele.classList.add('d-none'));
                this.showEle(this.registerSection);
            })

            this.querySelector(this.selectors.signUpHide)?.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();

                this.hideEle(this.registerSection);
                this.showEle(this.loginSection);
            })

            this.querySelectorAll('input').forEach(ele => ele.addEventListener("input", (e) => {
                let value = e.target.value;
                e.target.classList.remove('error');
                e.target.closest('div')?.querySelector('label span.error')?.classList.add('d-none');
                if (!value) {
                    e.target.classList.add('error');
                    e.target.closest('div')?.querySelector('label span.error')?.classList.remove('d-none');
                }

                let wrapper = e.target.closest('.form-group') || e.target.closest('div');
                if (value && (e.target.closest('.new-login-wrapper #customerEmail') || e.target.closest('#registerCustomerEmail'))) {
                    let error_msg = wrapper.querySelector('label .error');
                    if (!value.includes('@') && error_msg) {
                        error_msg?.classList.remove('d-none');
                        error_msg.innerHTML = 'Must include @ symbol';
                        wrapper.querySelector('input').classList.add('error');
                    } else {
                        wrapper.querySelector('label .error')?.classList.add('d-none');
                    }
                }
            }))
        }

        _loadButton(el, load = true) {
            let button  = el.querySelector('[type="submit"]');
            if (button) {
                load ? button?.classList?.add('loading')
                    : button?.classList?.remove('loading');
            }
        }
}
  customElements.define("custom-account-modal", customAccountModal);

/**
* Tab HTML
*/
class customTabs extends HTMLElement {
  constructor() {
    super();
   

    this.tabLinks = this.querySelectorAll('.tablink');
    this.tabContainers = this.querySelectorAll('.tabcontent');
    this.tabLinks.forEach( link => link.addEventListener('click', this.toggleTabs.bind(this)));
  }

  /**
   * Focus Out Event to close drawer
   *
   * @param {event} Event instance
   */
  focusOut(event){
    
  }

  /**
   * Escape Key Press to close drawer when focus is within the container
   *
   * @param {event} Event instance
   */
  onKeyUp(event) {
    if(event.code?.toUpperCase() !== 'ESCAPE') return;
  }

  /**
   * Toggle Tabs on link click
   *
   * @param {event} Event instance
   */
  toggleTabs(event){
    event.preventDefault();
    event.stopPropagation();

    const currentTab = event.currentTarget;
    const tabLink = currentTab.querySelector('[data-toggle="tab"]');
    const tabContainer = document.querySelector(tabLink.dataset.tabcontent);

    this.openTab(currentTab, tabContainer)

    // let isOpen = currentTab.classList.contains('open');
    // isOpen ? this.closeTab(currentTab, tabContainer) : this.openTab(currentTab, tabContainer);
  }

  /**
   * Open Tab Container
   *
   * @param {Node} currentTab Tab Container Open link
   * @param {Node} tabContainer Tab Container to open
   */
  openTab(currentTab, tabContainer) {
    this.tabContainers.forEach(container => {
      container.classList.remove('open');
      const linkEle = document.querySelector('.tablink a[data-toggle="tab"][data-tabcontent="#'+container.id+'"]');
      if(linkEle){
        linkEle.setAttribute('aria-expanded', false);
        if(linkEle.closest('.tablink')){ linkEle.closest('.tablink').classList.remove('open');}
      }
    });
    currentTab.classList.add('open');
    currentTab.querySelector('[data-toggle="tab"]').setAttribute('aria-expanded', true);
    tabContainer.classList.add('open');
  }

  /**
   * Close Tab Container
   *
   * @param {Node} currentTab Tab Container link
   * @param {Node} tabContainer Tab Container to close
   */
  closeTab(currentTab, tabContainer) {
    currentTab.classList.remove('open');
    currentTab.querySelector('[data-toggle="tab"]').setAttribute('aria-expanded', false);
    tabContainer.classList.remove('open');
  }
}
customElements.define("custom-tabs", customTabs);/**
* Accordion HTML
*/
class customAccordion extends HTMLElement {
  constructor() {
    super();
    this.accordionType = this.dataset.accordiontype;
    this.toggleBtns = this.querySelectorAll('.accordion__toggle');
    this.accordionCloseBtn = this.querySelectorAll('.accordion__close');
    this.toggleBtns.forEach(button => button.addEventListener('click', this.toggleAccordionBlock.bind(this)));
    this.accordionCloseBtn.forEach(button => button.addEventListener('click', this.closeAccordion.bind(this)));
  }

  closeAccordion() {
    let siblingBlocks = this.querySelectorAll('.accordion__container');
    siblingBlocks.forEach(element => {
      element.classList.remove('open');
      element.querySelector('.accordion__block').classList.remove('open');
      element.querySelector('.accordion__toggle').setAttribute('aria-expanded', false);
    });
  }

  /**
   * Focus Out Event to close drawer
   *
   * @param {event} Event instance
   */
  focusOut(event){
    
  }

  /**
   * Escape Key Press to close drawer when focus is within the container
   *
   * @param {event} Event instance
   */
  onKeyUp(event) {
    if(event.code?.toUpperCase() !== 'ESCAPE') return;
  }

  /**
   * Toggle Tabs on link click
   *
   * @param {event} Event instance
   */
   toggleAccordionBlock(event){
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    const toggleBtn = event.currentTarget;
    const targetContainer = toggleBtn.parentNode;
    const isOpen = targetContainer.classList.contains('open');
    isOpen ? this.closeAccordionBlock(toggleBtn) : this.openAccordionBlock(toggleBtn);

      document.querySelectorAll('[data-product-accordion] a[href="#size__chart"]').forEach(function(ele) {
          ele.addEventListener('click', function(event) {
              document.querySelector(`#new-size-guide-popup`)?.show(ele);
            })
    })
  }

  /**
   * Open Tab Container
   *
   * @param {Node} toggleBtn Accordion Block Open link
   */
   openAccordionBlock(toggleBtn) {
    let targetContainer = toggleBtn.parentNode;
    toggleBtn.setAttribute('aria-expanded', true);
    Utility.toggleElement(targetContainer, 'open');
    if(this.accordionType == 'single'){
      let siblingBlocks = targetContainer.parentNode.querySelectorAll('.accordion__container');
      siblingBlocks.forEach(element => {
        if(element == targetContainer){ return; }
        element.classList.remove('open');
        element.querySelector('.accordion__block')?.classList?.remove('open');
        element.querySelector('.accordion__toggle')?.setAttribute('aria-expanded', false);
      });
    }

      setTimeout(() => {
      const el = toggleBtn.closest('.mobile-nav-link.accordion__toggle');

      if (el) {
          const scrollContainer = el.closest('.drawer-body');

          if (scrollContainer) {
              const containerRect = scrollContainer.getBoundingClientRect();
              const rect = el.getBoundingClientRect();
              const isInView = rect.top >= containerRect.top && rect.bottom <= containerRect.bottom;

              if (!isInView) {
                  scrollContainer.scrollTop += (rect.top - containerRect.top);
              }
          }
          let linkTitle = el.getAttribute('data-link-text');
          linkTitle = this.stringToSlug(linkTitle);
          if (linkTitle) this.addToCookie(linkTitle);
      }
      }, 200)
    Utility.trapFocus(targetContainer);

  }

  /**
   * Close Tab Container
   *
   * @param {Node} currentTab Tab Container link
   * @param {Node} tabContainer Tab Container to close
   */
   closeAccordionBlock(toggleFilterBtn) {
    const targetContainer = toggleFilterBtn.parentNode;
    toggleFilterBtn.setAttribute('aria-expanded', false);
    Utility.toggleElement(targetContainer, 'close');
    Utility.removeTrapFocus(targetContainer);

      const el = toggleFilterBtn.closest('.mobile-nav-link.accordion__toggle');

      if (el) {
          let linkTitle = el.getAttribute('data-link-text');
          linkTitle = this.stringToSlug(linkTitle);
          if (linkTitle) this.removeFromCookie(linkTitle);
      }

  }
    getCookie(name) {
        const m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
        return m ? decodeURIComponent(m[1]) : null;
    }
    setCookie(name, value, maxAgeSeconds) {
        document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; Max-Age=${maxAgeSeconds}; Path=/; SameSite=Lax`;
    }
    readOpenSet() {
        try {
            const raw = this.getCookie('mobile_menu_items');
            const arr = raw ? JSON.parse(raw) : [];
            return new Set(Array.isArray(arr) ? arr : []);
        } catch {
            return new Set();
        }
    }
    writeOpenSet(set) {
        this.setCookie('mobile_menu_items', JSON.stringify([...set]), 1800);
    }
    addToCookie(id) {
        const openSet = new Set([id]);
        this.writeOpenSet(openSet);
    }
    removeFromCookie(id) {
        const openSet = this.readOpenSet();
        openSet.delete(id);
        if (openSet.size === 0) {
            // Clear cookie by setting Max-Age=0
            this.setCookie('mobile_menu_items', '[]', 0);
        } else {
            this.writeOpenSet(openSet);
        }
    }
    stringToSlug(str) {
       if (!str) return '';

        return str
            .toLowerCase()
            .trim()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .replace(/[^a-z0-9\s-]/g, "")
            .replace(/\s+/g, "-")
            .replace(/-+/g, "-");
    }
}
customElements.define("custom-accordion", customAccordion);class customSelect extends HTMLElement{
  constructor() {
    super();
    this.selectContainer = this.querySelector('.custom--select');
    this.select = this.querySelector('ul');
    this.initOption = this.querySelector('.default:not(.cart_rebuy_custom .default)');
    this.cartInitOption = this.querySelector('.default_selection');
    this.options = this.select.querySelectorAll('li');

    this.options.forEach(option => option.addEventListener('click', this.toggleOptions.bind(this)));
    this.initOption?.addEventListener('click', this.manageVisibility.bind(this));
    this.cartInitOption?.addEventListener('click', this.manageVisibility.bind(this));

    this.addEventListener('click', (event) => {
      event.stopPropagation();
    });
    document.body.addEventListener('click', ()=> {
      Utility.toggleElement(this.selectContainer, 'close')
    });
  }

  /**
   * Toggle custom select option
   * @param event 
   */
  toggleOptions(event){
    let _this = event.currentTarget;
    this.options.forEach(option => option.classList.remove('selected'));
    _this.classList.add('selected');
    if(_this.querySelector('.option_txt')){
      this.initOption.querySelector('.option_txt').innerHTML = _this.querySelector('.option_txt').innerHTML;
    }
    Utility.toggleElement(this.selectContainer, 'close');
  }

  /**
   * Hide/Show of custom select option
   * @param event 
   */
  manageVisibility(event){
    let isOpen = this.selectContainer.classList.contains('open');
    isOpen ? Utility.toggleElement(this.selectContainer, 'close') : Utility.toggleElement(this.selectContainer, 'open');
  }
}
customElements.define('custom-select', customSelect);class CustomOptionSelect extends HTMLElement {
      constructor() {
          super();
          this.selectWrapper = this.querySelector('.custom-select-wrapper');
          this.selectTrigger = this.querySelector('.custom-select-trigger');
          this.customOptions = this.querySelector('.custom-options');
          this.customOptionsItems = this.querySelectorAll('.custom-option');

          this.selectTrigger.addEventListener('click', this.toggleOptions.bind(this));
          this.customOptionsItems.forEach(option => {
              option.addEventListener('click', this.selectOption.bind(this, option));
          });
          document.addEventListener('click', this.closeOptionsOnClickOutside.bind(this));
      }

      toggleOptions() {
          let shouldScroll = false;
          let modalEle = this.selectWrapper?.closest('.modal');
          if (this.checkVerticalScroll(modalEle)) {
              shouldScroll = true;
          }
          this.customOptions.classList.toggle('open');
          this.selectWrapper.classList.toggle('open');

          let isMobile = window.innerWidth <= 576;
          if (isMobile && shouldScroll && this.querySelector('.custom-select-wrapper.open') && this.selectTrigger.closest('[data-size-select-container]')) {
              if (this.checkVerticalScroll(modalEle)) {
                  modalEle.scrollTo({
                      top: modalEle.scrollHeight + 100,
                      behavior: 'smooth'
                  })
              }
          }
      }

      checkVerticalScroll(container) {
          return container && container.scrollHeight > container.clientHeight;
      }

      selectOption(option) {
          if (this.selectTrigger.querySelector('[data-style-select]')) {
              this.selectTrigger.querySelector('[data-style-select]').textContent = option.dataset.show;
              this.selectTrigger.querySelector('[data-style-select]').setAttribute('data-style-select', option.dataset.value)
          } else {
              this.selectTrigger.querySelector('[data-size-select]').textContent = option.dataset.show;
              this.selectTrigger.querySelector('[data-size-select]').setAttribute('data-size-select', option.dataset.value)
          }

          this.customOptions.classList.remove('open');
          this.selectWrapper.classList.remove('open');
      }

      closeOptionsOnClickOutside(event) {
          if (!this.selectWrapper.contains(event.target)) {
              this.customOptions.classList.remove('open');
              this.selectWrapper.classList.remove('open');
          }
      }
  }

  customElements.define('custom-option-select', CustomOptionSelect);/**
* Custom Video
*/
class customVideo extends HTMLElement {
  constructor() {
    super();

    this.container = this.closest('.custom-video-container');
    this.triggerVideo = this.querySelector('[data-trigger-video]');
    this.pauseVideo = this.querySelector('[data-pause-video]');
    this.fullWidthTriggerBtn = (this.container) ? this.container.querySelector('[data-trigger-videobtn]') : null;
    this.placementType = this.getAttribute('data-placement');
    this.type = this.getAttribute('data-video-type');
    this.videoID = this.getAttribute('data-video-id');
    this.contentSection = this.querySelector('.content-section');
    this.videoSection = this.querySelector('.video-section');
    if(this.placementType == 'popup') this.videoSection = this.videoModal.querySelector('.video-section');

    if(window.screen.width <= 767 && this.dataset.mobilevideo){
      this.videoID = this.dataset.mobilevideo;
    }

    this.bindEvents();
  }

  /**
   * Binding events on the video button
   */
  bindEvents(){
    this.managePosterVideos();
    if(this.triggerVideo) this.triggerVideo.addEventListener('click', this.toggleView.bind(this));
    if(this.placementType == 'grid') this.addEventListener('focusout', this.focusOut.bind(this));

    if(this.fullWidthTriggerBtn) {
      this.fullWidthTriggerBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.triggerVideo.dispatchEvent(new Event('click'));
      });
    }
  }

  /**
   * Focus Out Event to close drawer
   *
   * @param {event} Event instance
   */
  focusOut(event){
    if(this.placementType == 'popup' && this.classList.contains('show--video')) this.toggleView();
  }

  /**
   * Toggle of video modal
   */
  toggleView(){
    let isOpen = this.classList.contains('show--video');
    let _this = this;
    if(isOpen){
      this.videoSection.innerHTML = '';
      this.classList.remove('show--video');
      setTimeout(() => {
        if(this.container) this.container.classList.remove('playing--video', 'video--playing', 'video--paused');
      }, 500);
    }else{
      const videoElement = this._buildVideo();
      let videoID = 'custom-video' + Math.floor((Math.random() * 100) + 1);
      videoElement.id = videoID;
      this.videoSection.appendChild(videoElement);
      this.classList.add('show--video');
      if(this.placementType == 'popup'){ openModal(this.videoModal, this.triggerVideo)}
      else if(this.container){ this.container.classList.add('playing--video');}

      this.manageOnScroll();
      this.managePosterVideos();
      if(this.type == 'local'){
        this.playPauseEvent(videoElement);
      }
    }
  }

  /**
   * 
   * Create the video html element
   */
  _buildVideo(){
    let video;
    if(window.screen.width <= 767 && this.dataset.mobilevideo){
      this.videoID = this.dataset.mobilevideo;
    }
    if(this.type == 'local'){
      video = document.createElement('video');
      video.src = this.videoID;
      if(this.dataset.autoplay == 'true') video.autoplay = this.dataset.autoplay;
      if(this.dataset.controls == 'true') video.controls = this.dataset.controls;
      if(this.dataset.muted == 'true') video.muted = this.dataset.muted;
      if(this.dataset.loop == 'true') video.loop = this.dataset.loop;
    }else if(this.type == 'youtube'){
      video = document.createElement( "iframe" );
      video.setAttribute( "allowfullscreen", "" );
      video.setAttribute( "frameborder", "0" );
      video.setAttribute( "src", "https://www.youtube.com/embed/"+ this.videoID +`?rel=0&showinfo=0&autoplay=${this.dataset.autoplay}&mute=${this.dataset.muted}&controls=${this.dataset.controls}&loop=${this.dataset.loop}&playlist=${this.videoID}&enablejsapi=1&origin=${window.origin}` );
    }else if(this.type == 'vimeo'){
      video = document.createElement( "iframe" );
      video.setAttribute( "allowfullscreen", "" );
      video.setAttribute( "frameborder", "0" );
      if(this.dataset.autoplay) video.setAttribute("allow", "autoplay");
      video.setAttribute( "src", "https://player.vimeo.com/video/"+ this.videoID + `?rel=0&showinfo=0&autoplay=${this.dataset.autoplay}&mute=${this.dataset.muted}&controls=${this.dataset.controls}&loop=${this.dataset.loop}&playlist=${this.videoID}`);
    }
    return video;
  }

  /**
   * 
   * Play / Pause 
  */
  playPauseEvent(video){
    const _this = this;
    if(this.type == 'youtube'){
      //  Code added after this component
    }
    if(this.type == 'local'){
      if(_this.pauseVideo){
        _this.pauseVideo.addEventListener('click', (e)=> {
          video.play();
        });
      }
      video.onplay = function(e) {
        if(_this.container){
          _this.container.classList.add('video--playing');
          _this.container.classList.remove('video--paused');
        }
      };
      video.onpause = function(e) {
        if(_this.container){
          _this.container.classList.add('video--paused');
          _this.container.classList.remove('video--playing');
        }
      };
      video.onended = function(e) {
        _this.container.classList.remove('playing--video', 'video--playing', 'video--paused');
        _this.classList.remove('show--video');
      };
    }
  }


  manageOnScroll(){
    let video = this.querySelector('video') || this.querySelector('iframe');
    let observer = new IntersectionObserver((entries, observer) => { 
      entries.forEach(entry => {
        if(entry.intersectionRatio == 0){
          if(this.type == 'local'){
            video.pause();
          }else if(this.type == 'youtube'){
            video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          }
        }
      });
    });
    observer.observe(video);
  }

  /**
   * Poster Video Autoplay
   *
  */
  managePosterVideos(){
    let posterVideo = this.querySelector('[data-postervideo]');
    if(posterVideo){
      let mobileSrc = posterVideo.getAttribute('data-mobileSrc');
      let windowSize = window.innerWidth || document.documentElement.clientWidth;
      if(windowSize < 768 && mobileSrc != null && mobileSrc != undefined){
        posterVideo.querySelector('source').src = mobileSrc;
      }
      const onIntersection = (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            if(entry.target) entry.target.play();
            observer.disconnect();
          }
        }
      };
      const observer = new IntersectionObserver(onIntersection);
      if(posterVideo != undefined) observer.observe(posterVideo);
    }
  }
}
customElements.define("custom-video", customVideo);/**
   * Manage KlaviyoForm submissions
   *
   */
 class customKlaviyo extends HTMLElement {
    responseInput;
    successMsg;
    subscribed;
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.successMsg = this.getAttribute('data-successmsg');
    this.subscribed = this.getAttribute('data-subscribed')
    this.responseInput = this.querySelector('[data-final-result]');
    this.defaultSuccessMessage = this.querySelector('[data-default-result]');
    this.form?.addEventListener('submit', this.onSubmitHandler.bind(this));
  }

  /**
   * Klaviyo Form Submit event
   *
   * @param {evt} Event instance
   */
   onSubmitHandler(evt) {
    evt.preventDefault();
    const formURL = this.form.getAttribute('action');
    const submitButton = this.querySelector('[type="submit"]');
    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    // Validation Code
    const listID = this.form.querySelector('[name="g"]').value;
    const emailID = this.form.querySelector('[name="email"]').value;
    if(emailID.trim().length <= 0){
      this.responseInput.innerHTML = 'Empty Email';
      this.manageResponseText(this.responseInput);
      return;
    }else if(listID == null || listID.length <= 0) {
      this.responseInput.innerHTML = 'Invalid List ID';
      this.manageResponseText(this.responseInput);
      return;
    }
    const data = new URLSearchParams();
    for (const pair of new FormData(this.form)) {
        data.append(pair[0], pair[1]);
    }
    fetch(formURL, {
        method: 'post',
        body: data,
    })
    .then((response) => response.json())
    .then((parsedState) => {
      if(parsedState.success == false){
        const errortext = parsedState.errors[0];
        this.responseInput.innerHTML = errortext;
        // this.manageResponseText(this.responseInput);
      }else if(parsedState.success == true && parsedState.data.is_subscribed == true){
        this.responseInput.innerHTML = this.subscribed;
        let formEl = this.querySelector('form');
        let isFooterForm = formEl?.getAttribute('data-footer-form');
        if (isFooterForm) {
          formEl?.querySelector('.footer-sign-up-info').classList.add('d-none');
        }
        else {
          formEl?.classList.add('d-none');
        }
        document.querySelector('.form-heading')?.classList.add('d-none');
        document.querySelector('.form-description-wrapper')?.classList.add('d-none');
        if (this.successMsg) {
          this.responseInput.innerHTML = this.successMsg;
          this.responseInput.classList.remove('d-none');
        }else{
          this.defaultSuccessMessage?.classList.add('show');
        }
          this.closest('footer')?.querySelector('.newsletter-text')?.classList.add('d-none');
          // this.manageResponseText(this.responseInput);
      }else{
        this.form.querySelector('[name="email"]').value = '';
        this.closest('footer')?.querySelector('.newsletter-text')?.classList.add('d-none');
        this.querySelector('form')?.classList.add('d-none');
        document.querySelector('.form-heading')?.classList.add('d-none');
        document.querySelector('.form-description-wrapper')?.classList.add('d-none');
        if (this.successMsg) {
          this.responseInput.innerHTML = this.successMsg;
          this.defaultSuccessMessage?.classList.remove('show');
        }else{
          this.defaultSuccessMessage?.classList.add('show');
        }
        this.manageResponseText(this.responseInput);
      }
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      submitButton.classList.remove('loading');
      submitButton.removeAttribute('disabled');
    });
  }

  manageResponseText(element){
    Utility.fadeEffect(element, 'fadeIn');
    setTimeout(() => {
      Utility.fadeEffect(element, 'fadeOut');
    }, 3000);
  }
}
customElements.define("custom-klaviyo", customKlaviyo);/**
   * Manage Custom Countdown Timer
   *
   */
class Countdown extends HTMLElement {
  constructor() {
    super();

    this.endDate = this.getAttribute("data-section_timer");
    if(this.endDate){
      this.manageCountdown(this.endDate);
    }
  }

  /**
   * 
   * @param endDate fetching from customization
   */
  manageCountdown(endDate){
    let countDownTimer = null;

    const tick = () => {
      let day,hour,min,sec,dStr,hStr,mStr,sStr;
      const currentDate = Date.now();
      const endDateMilliseconds = new Date(endDate).getTime();
      const difference = endDateMilliseconds - currentDate;

      if (difference < 0) {
        this.classList.add('d-none');
        this.removeAttribute("data-start_date");
        clearInterval(countDownTimer);
        countDownTimer = null;
        return;
      }

      day  = Math.floor(difference / 86400000);
      hour = Math.floor((difference % 86400000) / 3600000);
      min  = Math.floor((difference % 3600000) / 60000);
      sec  = Math.floor((difference % 60000) / 1000);

      dStr = ("0" + day).slice(-2).split('');
      hStr = ("0" + hour).slice(-2).split('');
      mStr = ("0" + min).slice(-2).split('');
      sStr = ("0" + sec).slice(-2).split('');

      if(this.querySelector('[data-countdown_day_1]')) this.querySelector('[data-countdown_day_1]').innerHTML=dStr[0];
      if(this.querySelector('[data-countdown_hour_1]')) this.querySelector('[data-countdown_hour_1]').innerHTML=hStr[0];
      if(this.querySelector('[data-countdown_min_1]')) this.querySelector('[data-countdown_min_1]').innerHTML=mStr[0];
      if(this.querySelector('[data-countdown_sec_1]')) this.querySelector('[data-countdown_sec_1]').innerHTML=sStr[0];

      if(this.querySelector('[data-countdown_day_2]')) this.querySelector('[data-countdown_day_2]').innerHTML=dStr[1];
      if(this.querySelector('[data-countdown_hour_2]')) this.querySelector('[data-countdown_hour_2]').innerHTML=hStr[1];
      if(this.querySelector('[data-countdown_min_2]')) this.querySelector('[data-countdown_min_2]').innerHTML=mStr[1];
      if(this.querySelector('[data-countdown_sec_2]')) this.querySelector('[data-countdown_sec_2]').innerHTML=sStr[1];
    };

    // Only run the interval when the element is in the viewport
    const visibilityObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (!countDownTimer) {
            tick(); // immediate tick on enter
            countDownTimer = setInterval(tick, 1000);
          }
        } else {
          if (countDownTimer) {
            clearInterval(countDownTimer);
            countDownTimer = null;
          }
        }
      });
    });
    visibilityObserver.observe(this);
  }
}
customElements.define("custom-countdown", Countdown);// document.addEventListener('rebuy:smartcart.show', function(event){
//   siteOverlay.prototype.showOverlay();
// });
// document.addEventListener('rebuy:smartcart.hide', function(event){
//   siteOverlay.prototype.hideOverlay();
//   let cartCount = this.querySelector('[data-desktop-cart] .cart-count_bf')?.innerHTML;
//   if (cartCount || cartCount == 0) {
//       this.querySelector('[data-mobile-cart] .cart-count_bf').innerHTML=cartCount
//   }
// });


/* Code to click any parent a tag while on click any image */
// Code added By Sayek on 19-03-2023
if (window.globalVariables?.template == 'index') {
    document.addEventListener('click', (event) => {
      if(event.target.closest('[data-link-category]') != null) {
        event.stopImmediatePropagation();
        if([null,undefined,'undefined','null'].includes(event.target.getAttribute('data-link-category')))
          event.target.closest('[data-link-category]').click();  
      }
    })
}

// document.addEventListener('click',(event)=>{
//     if (event.target.nodeName.toLowerCase() != 'a' && event.target.closest('a') && event.target.closest('.site-header')  && event.target.closest('[data-link-category]') ) {
//         event.preventDefault();
//         event.target.closest('a').click();
//         window.location.href=event.target.closest('a').getAttribute('href');
//     }
// })

document.getElementById('site-blur')?.addEventListener('click', function () {
  if (document.getElementById('site-blur')?.classList.contains('d-block')) {
      document.getElementById('mobile-nav-close')?.click()
  }
})

// Function to show the hidden element when scrolled 50px
function showHiddenElement() {
  const hiddenElement1 = document.querySelector('#chatbotize');

  if (window.scrollY > 50) {
    if (hiddenElement1) {
      hiddenElement1.style.display = 'block';
    }
  }

  const consentCancelButton = document.querySelector('.isense-close-icon.isense-cc-submit-consent');
  if (consentCancelButton && window.scrollY > 120) {
      consentCancelButton?.click();
  }
}

// Throttle scroll via rAF — prevents layout thrash on every scroll frame
let _scrollTicking = false;
window.addEventListener('scroll', () => {
  if (!_scrollTicking) {
    requestAnimationFrame(() => {
      showHiddenElement();
      _scrollTicking = false;
    });
    _scrollTicking = true;
  }
}, { passive: true });

// Initial check on page load
window.addEventListener('load', showHiddenElement);


document.querySelectorAll('[data-dropdown-menu] li a').forEach((ele)=>{
  ele.addEventListener('click',(event)=>{
    if (event.target.closest('mobile-nav')) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      event.target.closest('a').click();
      window.location.href=event.target.closest('a').getAttribute('href'); 
    }
  })
})

class VideoMediaBtn extends HTMLElement {
  constructor() {
    super();
    this.bindEvents();
  }

  bindEvents() {
    this.querySelector('[data-product-media] [data-product-play-icon]').addEventListener('click', () => {
        this.querySelector('.swiper-pagination .swiper-pagination-bullet.video-icon').click();
    });
  }
}
customElements.define('video-media-btn', VideoMediaBtn);


class VideoMedia extends HTMLElement {
    constructor() {
      super();
      this.bindEvents();
    }

  bindEvents() {
    this.querySelectorAll('[data-play-icon]').forEach((ele)=>{
      ele.addEventListener('click',(event)=>{
        event.preventDefault();
        event.stopPropagation();
        if (window.innerWidth < 768) {
          ele.closest('[data-custom-video]')?.querySelectorAll('video.mobile-video').forEach((videoEle)=>{
            videoEle.play();
          })
        }
        if (window.innerWidth >= 768) {
          ele.closest('[data-custom-video]')?.querySelectorAll('video.desktop-video').forEach((videoEle)=>{
            videoEle.play();
          })
        }

        ele.classList.add('d-none');
        ele.closest('[data-custom-video]')?.querySelector('[data-pause-icon]').classList.remove('d-none');
      })
    });

    this.querySelectorAll('[data-pause-icon]').forEach((ele)=>{
      ele.addEventListener('click',(event)=>{
        event.preventDefault();
        event.stopPropagation();
        if (window.innerWidth < 768) {
          ele.closest('[data-custom-video]')?.querySelectorAll('video.mobile-video').forEach((videoEle)=>{
            videoEle.pause();
          })
        }
        if (window.innerWidth >= 768) {
          ele.closest('[data-custom-video]')?.querySelectorAll('video.desktop-video').forEach((videoEle)=>{
            videoEle.pause();
          })
        }

        ele.classList.add('d-none');
        ele.closest('[data-custom-video]')?.querySelector('[data-play-icon]').classList.remove('d-none');
      })
    });

    this.querySelectorAll('[data-speaker-off]')?.forEach((ele)=>{
      ele.addEventListener('click',(event)=>{
        event.preventDefault();
        event.stopPropagation();
        if (window.innerWidth < 768) {
          ele.closest('[data-custom-video]')?.querySelectorAll('video.mobile-video').forEach((videoEle)=>{
            videoEle.muted = false;
          })
        }
        if (window.innerWidth >= 768) {
          ele.closest('[data-custom-video]')?.querySelectorAll('video.desktop-video').forEach((videoEle)=>{
            videoEle.muted = false;
          })
        }

        ele.classList.add('d-none');
        ele.closest('[data-custom-video]')?.querySelector('[data-speaker-on]')?.classList.remove('d-none');
      })
    });

    this.querySelectorAll('[data-speaker-on]')?.forEach((ele)=>{
      ele.addEventListener('click',(event)=>{
        event.preventDefault();
        event.stopPropagation();
        if (window.innerWidth < 768) {
          ele.closest('[data-custom-video]')?.querySelectorAll('video.mobile-video').forEach((videoEle)=>{
            videoEle.muted = true;
          })
        }
        if (window.innerWidth >= 768) {
          ele.closest('[data-custom-video]')?.querySelectorAll('video.desktop-video').forEach((videoEle)=>{
            videoEle.muted = true;
          })
        }

        ele.classList.add('d-none');
        ele.closest('[data-custom-video]')?.querySelector('[data-speaker-off]')?.classList.remove('d-none');
      })
    });
  }
}
customElements.define('video-media', VideoMedia);

function isVisible(el) {
  const style = window.getComputedStyle(el);
  const rect = el.getBoundingClientRect();
  return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      style.opacity !== '0' &&
      rect.height > 0 &&
      rect.width > 0
  );
}

const changeAttentiveProperties = () => {
    try {
        // Try to fix immediately if element already exists
        const existingEl = document.querySelector('#attentive_overlay iframe');
        if (existingEl && isVisible(existingEl)) {
            existingEl.closest('#attentive_overlay')?.style?.setProperty('z-index', '10000', 'important');
            return;
        }
        // Observe the narrowest possible target, not all of document.body
        const observeTarget = document.querySelector('#attentive_overlay') || document.body;
        const observer = new MutationObserver(() => {
            const el = document.querySelector('#attentive_overlay iframe');
            if (el && isVisible(el)) {
                el.closest('#attentive_overlay')?.style?.setProperty('z-index', '10000', 'important');
                observer.disconnect();
            }
        });
        observer.observe(observeTarget, { childList: true, subtree: true });
    } catch (e) {
        console.log(e);
    }
};

class ChatOpener {
    constructor(customBtnSelector, chatContainerSelector) {
        this.customBtnSelector = customBtnSelector;
        this.chatContainerSelector = chatContainerSelector;
        this.init();
    }

    init() {
        const customChatOpener = document.querySelectorAll(this.customBtnSelector);

        if (customChatOpener) {
            customChatOpener.forEach(btn => {
                btn.addEventListener("click", (e) => {
                    e.preventDefault();
                    this.toggleChat();
                });
            });
        }
    }

    toggleChat() {
        const chatContainer = document.querySelector(this.chatContainerSelector);
        if (!chatContainer) return;

        chatContainer.style.display = "unset";

        if (window.GorgiasChat?.open && window.GorgiasChat.close && window.GorgiasChat?.isOpen) {
            if (window.GorgiasChat?.isOpen()) {
                window.GorgiasChat.close();
            }
            else {
                window.GorgiasChat.open();
            }
        }
    }
}

// Single consolidated DOMContentLoaded handler
document.addEventListener("DOMContentLoaded", () => {
    new ChatOpener(".custom-chat-with-us-button", "#gorgias-chat-container");
    changeAttentiveProperties();
    handleSubscribfyText();
});

if (document.querySelector('.paid_shipping_ab_test')) {
  document.body?.classList?.add('us_paid_shipping_test');
}

/* Global Cart API Interceptor for 3rd Party Apps coverage (Fast Simon etc) */
(function() {
  function refreshUpsellWidget() {
      if (window.FastSimon?.upsell?.reload) {
        window.FastSimon.upsell.reload();
      }
    }

    // Intercept fetch — check URL BEFORE awaiting response to avoid wrapping every request
    const originalFetch = window.fetch;
    window.fetch = function(...args) {
        const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
        const isCartUrl = url.includes('/cart/add') || url.includes('/cart/change');
        const result = originalFetch.apply(this, args);
        if (isCartUrl) {
            result.then(response => {
                if (response.ok) {
                    setTimeout(() => {
                        refreshUpsellWidget();
                        const cartForm = document.querySelector('cart-form');
                        if (cartForm) cartForm.getCartData('open_drawer');
                    }, 500);
                }
            }).catch(() => {});
        }
        return result;
    };

    // Intercept XMLHttpRequest
    const originalXHROpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method, url) {
        this.addEventListener('load', function() {
            if (url && (url.includes('/cart/add') || url.includes('/cart/change'))) {
                setTimeout(() => {
                    refreshUpsellWidget();
                    const cartForm = document.querySelector('cart-form');
                    if (cartForm) {
                        cartForm.getCartData('open_drawer');
                    }
                }, 500);
            }
        });
        originalXHROpen.apply(this, arguments);
    };
})();

/* Update Subscribfy text: Remove "The Woxer Circle " prefix which comes from Shopify App dynamically */
function handleSubscribfyText() {
  const elements = document.querySelectorAll('#subscribfy-page [data-slot="card"] .bg-primary [data-slot="badge"].inline-flex p');
  let replaced = false;
  elements.forEach(el => {
    if (el.textContent.includes('The Woxer Circle ')) {
      el.textContent = el.textContent.replace('The Woxer Circle ', '');
      replaced = true;
    }
  });
  return replaced;
}

// Observe only until the text is replaced, then disconnect — prevents permanent body watcher
const subscribfyObserver = new MutationObserver(() => {
  if (handleSubscribfyText()) subscribfyObserver.disconnect();
});

// Observe the subscribfy page element if it exists, otherwise observe body as fallback
const _subscribfyRoot = document.querySelector('#subscribfy-page') || document.body;
subscribfyObserver.observe(_subscribfyRoot, { childList: true, subtree: true });

// Run once immediately (DOMContentLoaded call handled in consolidated listener above)
handleSubscribfyText();


